import styled from 'styled-components';

export const StyledLefletMap = styled.div(props => ({
  flex: 1,
  position: 'relative',
  display: 'flex',
  overflow: 'hidden',
  userSelect: 'none',
  background: '#cad2d3',
  "& .leaflet-top.leaflet-left": {
    display: 'flex',
  },
  "& .leaflet-tooltip": {
    boxShadow: 'none',
  },
  // "& .leaflet-map-pane": {
  //   flex: 1,
  //   "& > .leaflet-pane": {
  //     height: '100%',
  //     width: '100%',
  //     position: 'absolute',
  //   },
  // },
  // "& .leaflet-control-container": {
  //   position: 'absolute',
  // },
}));